import type { ServicePage } from "./servicePages";
import { VAN_INFO_PAGES_A } from "./vanInfoPages.a";
import { VAN_INFO_PAGES_B } from "./vanInfoPages.b";
import { VAN_INFO_PAGES_C } from "./vanInfoPages.c";
import { VAN_INFO_PAGES_D } from "./vanInfoPagesD";

/** Hub article of the Sprinter model/interior/seating topic cluster. */
export const VAN_INFO_HUB_SLUG = "maybach-sprinter-van";

const merged: Record<string, ServicePage> = {
  ...VAN_INFO_PAGES_A,
  ...VAN_INFO_PAGES_B,
  ...VAN_INFO_PAGES_C,
  ...VAN_INFO_PAGES_D,
};

/**
 * Every spoke page points at the hub article, and the hub links back out
 * through its related list — a classic topic-cluster internal link graph.
 */
export const VAN_INFO_PAGES: Record<string, ServicePage> = Object.fromEntries(
  Object.entries(merged).map(([slug, page]) => [
    slug,
    slug === VAN_INFO_HUB_SLUG || slug === "sprinter-van-seating-capacity"
      ? page
      : { ...page, hubSlug: page.hubSlug ?? VAN_INFO_HUB_SLUG },
  ]),
);

export const VAN_INFO_SLUGS = Object.keys(VAN_INFO_PAGES);
